import mergeWith from "lodash/mergeWith";
import {
  migrateTurnstileDeviceForUi,
  normalizeWorkspaceDevices,
} from "app/pages/customers/dsok/utils/normalizeDsokWorkspaces";

export const DEVICE_TYPE_VALUES = [
  "ticket",
  "kitchen",
  "accessTicket",
  "turnstile",
  "compressor",
];

export function generateUuidV4() {
  if (
    typeof crypto !== "undefined" &&
    typeof crypto.randomUUID === "function"
  ) {
    return crypto.randomUUID();
  }
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

export const createDefaultWorkspace = (uuid) => ({
  uuid,
  name: "workspace",
  isActive: true,
  features: {
    ticketPrintingEnabled: true,
    wristbandPrintingEnabled: false,
  },
  pos: {
    isPosEnabled: false,
    menu: {
      pos: { isActive: false, showCategories: false },
      ticketControl: { isActive: false },
      turnstiles: { isActive: false },
    },
  },
  devices: [],
});

/**
 * Merge API/partial workspace with defaults so POS/detail editors match admin workspace shape.
 * @param {object} ws
 */
export function mergeWorkspaceWithDefaults(ws) {
  if (!ws || typeof ws !== "object") {
    return createDefaultWorkspace(generateUuidV4());
  }
  const id = ws.uuid != null ? String(ws.uuid) : generateUuidV4();
  // Replace `devices` entirely — plain lodash merge merges arrays by index and can
  // corrupt device objects when length/type changes (POS workspace save payload).
  return mergeWith({}, createDefaultWorkspace(id), ws, (objValue, srcValue, key) => {
    if (key === "devices") {
      return normalizeWorkspaceDevices(srcValue).map(migrateTurnstileDeviceForUi);
    }
    if (key === "isActive") {
      if (srcValue === undefined || srcValue === null) {
        return true;
      }
      return Boolean(srcValue);
    }
    return undefined;
  });
}
